<template>
    <div>
        <label class="customRadioContainer" 
        v-for="(option, i) in options" :key="('option_'+i)"
        :class="{ checked: selectedOption == option.value}"
        @click="onRadioChange(option)">
            <span class="font--normal">{{option.name}}</span>
            <span class="checkmark"></span>
        </label>
    </div>
</template>

<script>
export default {
    name: "RcclRadio",
    props: {
        options: {
            type: Array,
            default () {
                return []
                // name
                // value
                // isSelected
            }
        }
    },
    beforeMount () {
        this.checkSelected()
    },
    data () {
        return {
            selectedOption: ''
        }
    },
    methods: {
        checkSelected () {
            const selectedOption = this.options.find(r=>r.isSelected)
            if (selectedOption) {
                this.selectedOption = selectedOption.value
            } else {
                this.selectedOption = ''
            }
        },
        onRadioChange (option) {
            this.selectedOption = option.value
            this.$emit('onChanged', this.selectedOption)
        }
    },
    watch: {
        options () {
            this.checkSelected()
        }
    }
}
</script>

<style lang="less" scoped>
.customRadioContainer {
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 44px;
    margin-left: 3px;
    text-align: right;
    margin-right: 10px;
    .font--normal {
        font-size: 15px;
        color: #646464;
    }
    .checkmark {
        position: absolute;
        top: 0;
        left: 3px;
        height: 18px;
        width: 18px;
        background-color: white;
        border: solid 1px #d3dadd;
        border-radius: 50%;
    }
}
.customRadioContainer.checked {
    .checkmark:after {
        content: "";
        position: absolute;
        display: block;
        top: 4px;
        left: 4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #0073bb;
    }
}
</style>